import React from "react";
import classNames from "classnames";
import { Button, ButtonSize } from "Components/ReactstrapSlim";
import { useCookies } from "react-cookie";

export interface SsoRegistrationOptions {
   RegistrationType: LSCommon.Enums.RegistrationType,
   MemberIdToLink?: Guid,
   OriginatingVenueId?: Guid,
   Email?: string,
   InvitationId?: Guid,
   InvitationOwnerId?: Guid,
   OwnerId?: Guid,
   ConnectionType?: LSCommon.MemberConnectionType,
}

export interface SsoButtonProps {
   ssoType: LSCrossTier.SsoType,
   size?: ButtonSize,
   ssoRegistrationOptions?: SsoRegistrationOptions,
}

export const SsoButton: React.FC<SsoButtonProps> = ({ ssoType, ssoRegistrationOptions, size = "lg" }) => {
   const getPopupDimensions = (ssoType): [number, number] => {
      switch (ssoType) {
         case LSCrossTier.SsoType.Apple:
            return [440, 678];
         case LSCrossTier.SsoType.Facebook:
            return [700, 350];
         case LSCrossTier.SsoType.Google:
            return [440, 555];
         case LSCrossTier.SsoType.LinkedIn:
            return [740, 680];
         case LSCrossTier.SsoType.Twitter:
            return [700, 350];
         default:
            return [440, 600];
      }
   }

   const onClick = () => {
      const [popupWidth, popupHeight] = getPopupDimensions(ssoType);
      var modelJson = encodeURIComponent(JSON.stringify({ SsoType: ssoType, ...ssoRegistrationOptions }));
      console.log(modelJson);
      LSHelper.Sso.popupSsoLogin(`/Account/StartSsoLogOn?model=${modelJson}`, popupWidth, popupHeight);
   }
   return (
      <Button className="btn-sso" color="secondary" size={size} fluid onClick={onClick}>
         <span className={classNames("btn-sso-icon", `btn-sso-icon-${LSCrossTier.SsoType.getKey(ssoType).toLowerCase()}`)}></span>
         Continue with {LSCrossTier.SsoType.describe(ssoType)}
      </Button>
   )
}

export interface SsoButtonsProps {
   size?: ButtonSize,
   ssoRegistrationOptions?: SsoRegistrationOptions,
}

export const SsoButtons: React.FC<SsoButtonsProps> = ({ size, ssoRegistrationOptions }) => {
   const [cookies] = useCookies(["sign-in-with-apple-enabled"]);
   
   const buttonTypes = cookies["sign-in-with-apple-enabled"]
      ? [
         LSCrossTier.SsoType.Google,
         LSCrossTier.SsoType.LinkedIn,
         LSCrossTier.SsoType.Apple,
      ]
      : [
         LSCrossTier.SsoType.Google,
         LSCrossTier.SsoType.LinkedIn
      ];

   return (
      <>
         {buttonTypes.map(bt => <SsoButton key={bt} size={size} ssoType={bt} ssoRegistrationOptions={ssoRegistrationOptions} />)}
      </>
   )
}